import './Navbar.css'
import logo from '../../assets/images/logo.webp'
import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Link as ScrollLink } from 'react-scroll'
const Navbar = () => {
    useEffect(() => {
        let menu = document.querySelector('#navtoggle');
        let navbar = document.querySelector('.nav-items');
        try {
            menu.onclick = () => {
                try {
                    menu.classList.toggle('fa-times');
                    navbar.classList.toggle('active');
                } catch (error) {

                }
            }
        } catch (error) {

        }
    }, [])
    const { pathname } = useLocation();
    return (
        <>
            <nav className='Navbar'>
                <Link to="/" className="navlogo" style={{ textDecoration: "none" }}>
                    <img src={logo} alt="" />
                    <span style={{ color: "white", fontSize: '2.5rem' }}>IITCEE 2026, Jan 22-23</span>
                </Link>
                <ul className="nav-items">
                    <li><Link to="/" className={pathname === "/" ? ('navactive') : ""}>Home</Link></li>
                    <li><Link to="/committes" className={pathname === "/committes" ? ('navactive') : ""}>Committees</Link></li>
                    <li><Link to="/keydates&fees" className={pathname === "/keydates&fees" ? ('navactive') : ""}></Link></li>
                    <li><Link to="/forauthors" className={pathname === "/forauthors" ? ('navactive') : ""}>For Authors</Link></li>
                    <li><Link to="/callforpapers" className={pathname === "/callforpapers" ? ('navactive') : ""}>Call For Papers </Link></li>
                    <li><Link to="/specialsessions" className={pathname === "/specialsessions" ? ('navactive') : ""}>Special Sessions </Link></li>
                    {/* <li><Link to="/programschedule" className={pathname === "/programschedule" ? ('navactive') : ""}>Program Schedule</Link></li>
                    <li><Link to="/registrationform" className={pathname === "/registrationform" ? ('navactive') : ""}>Registration</Link></li>
                    <li><Link to="/payments" className={pathname === "/payments" ? ('navactive') : ""}>Payments</Link></li> */}
                    <li><ScrollLink to='Footer' spy={true} smooth={true} style={{ cursor: 'pointer' }}>Contact Us</ScrollLink></li>
                </ul>
                <i id='navtoggle' className="fas fa-bars" style={{ fontSize: '3rem', color: 'white' }} />
            </nav>
        </>
    )
}

export default Navbar